import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Helmet } from 'react-helmet-async';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import ProductListingSEOLinkedData from './ProductListingSEOLinkedData';
const ProductListingPageTitleAndMetaTags = () => {
  const $ = _c(19);
  const {
    loading,
    pageHtmlTitle: t0,
    pageMetaDescription: t1,
    pageName: t2
  } = useProductListingPageContext();
  const pageHtmlTitle = t0 === undefined ? "" : t0;
  const pageMetaDescription = t1 === undefined ? "" : t1;
  const pageName = t2 === undefined ? "" : t2;
  let t3;
  if ($[0] !== pageHtmlTitle) {
    t3 = <title>{pageHtmlTitle}</title>;
    $[0] = pageHtmlTitle;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== pageMetaDescription) {
    t4 = <meta name="description" content={pageMetaDescription} />;
    $[2] = pageMetaDescription;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <meta property="og:type" content="category" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== pageName) {
    t6 = <meta property="og:title" content={pageName} />;
    $[5] = pageName;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== pageMetaDescription) {
    t7 = <meta property="og:description" content={pageMetaDescription} />;
    $[7] = pageMetaDescription;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t6 || $[12] !== t7) {
    t8 = <Helmet>{t3}{t4}{t5}{t6}{t7}</Helmet>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== loading) {
    t9 = !loading && <ProductListingSEOLinkedData />;
    $[14] = loading;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default ProductListingPageTitleAndMetaTags;